import React from 'react';

type DimensionRowProps = {
  label: React.ReactNode;
  valueReadonly?: React.ReactNode;
  editable?: boolean;
  inputNode?: React.ReactNode;
  labelClassName?: string;
  itemClassName?: string;
};

export const DimensionRow: React.FC<DimensionRowProps> = ({
  label,
  valueReadonly,
  editable = false,
  inputNode,
  labelClassName,
  itemClassName,
}) => {
  return (
    <div className={`item-detail_content_param_size_list_item ${itemClassName ?? ''}`}>
      <label className={labelClassName ?? ''}>{label}</label>

      {editable ? (
        <div className="d-flex align-items-center gap-2">{inputNode}</div>
      ) : (
        <div className="value">
          <span className="colon">:</span> <span className="number">{valueReadonly}</span>
        </div>
      )}
    </div>
  );
};
